
export default class ParametrosSolicitud {

    constructor() {
        this.IdEntidad = "";
        this.IdClaseDato = 0;
        this.FechaSolicitud = "";
        this.TipoSolicitud = 0;
        this.TipoEstado = 0;
        this.Identificacion = "";
        this.Nombre = "";
    }

    IdEntidad: string;
    IdClaseDato: number;
    FechaSolicitud: string;
    TipoSolicitud: number;
    TipoEstado: number;
    Identificacion: string;
    Nombre: string;
}